import React, { Component, PropsWithChildren, createRef, RefObject } from 'react';
import Alert from '../Alert/Alert';
import { IGlobalFormErrorProps } from './types';

export class GlobalFormError extends Component<PropsWithChildren<IGlobalFormErrorProps>, {}> {
  private alert: RefObject<HTMLDivElement>;

  constructor(props: IGlobalFormErrorProps) {
    super(props);
    this.alert = createRef();
  }

  public componentDidMount() {
    this.focus();
  }

  public componentDidUpdate(prevProps: IGlobalFormErrorProps) {
    if (prevProps.submitCount !== this.props.submitCount) {
      this.focus();
    }
  }

  public render() {
    return (
      <div tabIndex={0} ref={this.alert}>
        <Alert danger={true}>{this.props.globalErrorMessage}</Alert>
      </div>
    );
  }

  private focus() {
    this.alert.current && this.alert.current.focus();
  }
}

export default GlobalFormError;
